import { newRequestId } from './request-id';

const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function isMutating(method?: string): boolean {
  return !!method && MUTATING.has(method.toUpperCase());
}

export function isAuthEndpoint(url: string): boolean {
  return url.includes('/auth/');
}

/**
 * Applies the standard request headers in place: Authorization (if a token is
 * present), Accept-Language, a correlation id, and an idempotency key on
 * mutating commands. Existing values are preserved so a caller-supplied
 * idempotency key (for retries) is not overwritten.
 */
export function applyStandardHeaders(
  headers: Headers,
  opts: { method?: string; token: string | null; language: string },
): void {
  if (opts.token) headers.set('Authorization', `Bearer ${opts.token}`);
  if (!headers.has('Accept-Language')) headers.set('Accept-Language', opts.language);
  if (!headers.has('X-Correlation-Id')) headers.set('X-Correlation-Id', newRequestId());
  if (isMutating(opts.method) && !headers.has('Idempotency-Key')) {
    headers.set('Idempotency-Key', newRequestId());
  }
}
